// 公共方法
import axios from "axios";
import qs from "qs";
export default {

    // get请求
    fetch(url, params = {}) {
        let user = JSON.parse(sessionStorage.getItem("user"));
        return new Promise((resolve, reject) => {
            axios
                .get(url, {
                    params: params,
                    headers: {
                        "Content-Type": "application/json;charset=UTF-8",
                        "operator": user ? user.userAccount : ""
                    }
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // post请求
    post(url, data) {
        let user = JSON.parse(sessionStorage.getItem("user"));
        return new Promise((resolve, reject) => {
            axios.post(url, data, {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    "operator": user ? user.userAccount : ""
                }
            }).then(
                response => {
                    resolve(response.data);
                },
                err => {
                    reject(err);
                }
            );
        });
    },

    // formData格式请求
    From(url, data) {
        let user = JSON.parse(sessionStorage.getItem("user"));
        return new Promise((resolve, reject) => {
            axios
                .post(url, qs.stringify(data), {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "operator": user ? user.userAccount : ""
                    }
                })
                .then(
                    response => {
                        resolve(response.data);
                    },
                    err => {
                        reject(err);
                    }
                );
        });
    },
}